import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { PaginationConfig, SorterResult } from 'antd/lib/table';
import Spin from 'src/components/common/Spin';
import { ErrorMessagesList } from '../../../types/QaErrors';
import { ColumnSorting, ErrorMessagesColumn, defaultPagination, getColumns } from './ErrorMessagesTable.config';
import styles from './ErrorMessagesTable.module.less';

export type ErrorMessagesTableProps = {
  items: ErrorMessagesList.Item[];
  sorting: ColumnSorting;
  loading?: boolean;
  page?: number;
  pageSize: number;
  total: number;
  onSortingChange: (sorting: ColumnSorting) => void;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
};

const ErrorMessagesTable: React.FC<ErrorMessagesTableProps> = ({
  items,
  sorting,
  loading,
  page,
  pageSize,
  total,
  onSortingChange,
  onPageChange,
  onPageSizeChange,
}) => {
  const [columns, setColumns] = useState<ErrorMessagesColumn[]>([]);
  const emptyText = <p className={styles.noResults}>No results found.</p>;
  const totalRender = () => <span className={styles.totalResults}>Total Results: {total}</span>;

  useEffect(() => {
    setColumns(getColumns(sorting));
  }, [sorting]);

  const handlePageChange = (page: number) => {
    onPageChange(page);
  };

  const handlePageSizeChange = (_: unused, size: number) => {
    onPageSizeChange(size);
  };

  const handleSorterChange = (_: unused, __: unused, sorter: SorterResult<ErrorMessagesList.Item>) => {
    const order =
      sorting.field === sorter.columnKey && sorter.order === undefined
        ? sorting.order === 'ascend'
          ? 'descend'
          : 'ascend'
        : sorter.order;

    onSortingChange({ field: sorter.columnKey as keyof ErrorMessagesList.Item, order: order });
  };

  const pagination: PaginationConfig = {
    ...defaultPagination,
    current: page,
    pageSize: pageSize,
    total: total,
    showTotal: totalRender,
    onChange: handlePageChange,
    onShowSizeChange: handlePageSizeChange,
  };

  return (
    <Spin spinning={loading}>
      <Table
        rowKey={(_, index) => String(index)}
        columns={columns}
        pagination={pagination}
        dataSource={items}
        onChange={handleSorterChange}
        tableLayout={'auto'}
        locale={{ emptyText }}
      />
    </Spin>
  );
};

export default ErrorMessagesTable;
